import React from 'react'
import Icon, { MediumOutlined, TwitterOutlined } from '@ant-design/icons'
import { useGA, useHover } from '~/hooks'
// @TODO: Remove antd
import { Tooltip } from 'antd'
import { StyledFooterSocialMedia, StyledLink } from './styled'
import { useTranslation } from 'react-i18next'

type SocialMediaChannel =
  | 'twitter'
  | 'medium'
  | 'discord'
  | 'github'
  | 'zendesk'

const MEDIA_LINK: Record<SocialMediaChannel, string> = {
  medium: 'https://tokenlon.medium.com',
  twitter: 'https://twitter.com/tokenlon',
  discord: 'https://discord.com/invite/CETmm86ueM',
  github: 'https://github.com/consenlabs/tokenlon-contracts',
  zendesk: 'https://support.tokenlon.im',
}

const GithubSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 19.9994C4 21.4994 4 17.4994 2 16.9994L9 19.9994ZM16 22.9994V19.1294C16.0375 18.6526 15.9731 18.1733 15.811 17.7232C15.6489 17.2732 15.3929 16.8629 15.06 16.5195C18.2 16.1694 21.5 14.9795 21.5 9.51945C21.4997 8.12328 20.9627 6.78065 20 5.76945C20.4559 4.54796 20.4236 3.1978 19.91 1.99945C19.91 1.99945 18.73 1.64945 16 3.47945C13.708 2.85827 11.292 2.85827 9 3.47945C6.27 1.64945 5.09 1.99945 5.09 1.99945C4.57638 3.1978 4.54414 4.54796 5 5.76945C4.03013 6.78815 3.49252 8.14291 3.5 9.54945C3.5 14.9694 6.8 16.1594 9.94 16.5494C9.611 16.8894 9.35726 17.2949 9.19531 17.7394C9.03335 18.1839 8.96681 18.6575 9 19.1294V22.9994"
      fill="currentColor"
    />
  </svg>
)

const discordSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.9966 15.8576C23.0149 16.354 22.9542 16.8956 22.9313 17.439C22.9232 17.6356 22.8464 17.7674 22.6791 17.8844C21.112 18.9797 19.4177 19.8142 17.6008 20.4063C17.3727 20.4808 17.2626 20.4287 17.1354 20.2435C16.8218 19.7861 16.5381 19.3127 16.2579 18.8353C16.1484 18.649 16.1661 18.5573 16.3799 18.4839C16.8316 18.3297 17.2586 18.1159 17.6776 17.8878C17.7733 17.8356 17.9458 17.827 17.9212 17.6625C17.9017 17.5301 17.5297 17.3679 17.4007 17.4195C17.144 17.5215 16.8923 17.6373 16.6333 17.7325C13.2797 18.9654 9.96102 18.8502 6.67561 17.47C6.57474 17.4275 6.46927 17.3267 6.35693 17.4115C6.24631 17.4952 6.06404 17.5462 6.05602 17.6924C6.04857 17.827 6.22969 17.8437 6.33343 17.901C6.75127 18.1314 7.1823 18.3354 7.62994 18.4999C7.78928 18.5584 7.83571 18.6215 7.744 18.7894C7.45054 19.3259 7.12326 19.84 6.77363 20.341C6.6888 20.4625 6.61027 20.4866 6.46411 20.4407C4.58355 19.8492 2.8457 18.9757 1.2414 17.8322C1.11702 17.7434 1.08263 17.6293 1.07117 17.4912C0.806938 14.3771 1.27292 11.3852 2.56198 8.52968C3.02969 7.49339 3.58566 6.50524 4.21213 5.55607C4.29983 5.4231 4.40529 5.33254 4.5526 5.26892C5.88006 4.69804 7.25165 4.27504 8.67425 4.01425C8.85251 3.98158 8.93849 4.02743 9.01013 4.17818C9.1368 4.44527 9.28353 4.70263 9.4039 4.97202C9.46064 5.09983 9.52598 5.1411 9.66412 5.12047C11.2134 4.8912 12.7638 4.89693 14.3131 5.12047C14.4604 5.14167 14.5315 5.10442 14.5922 4.9617C14.7074 4.69002 14.8559 4.43266 14.9848 4.16671C15.0519 4.02858 15.1333 3.97814 15.3001 4.00852C16.7129 4.26644 18.0788 4.67454 19.3965 5.24484C19.5599 5.31534 19.6825 5.41565 19.7834 5.56525C21.4181 7.99319 22.4968 10.6355 22.8625 13.5512C22.9565 14.2998 23.0098 15.0523 22.9977 15.8565L22.9966 15.8576ZM15.6566 15.2323C16.1048 15.2375 16.5009 15.0925 16.8448 14.8099C17.8106 14.016 17.9183 12.4507 17.0735 11.5256C16.3473 10.7306 15.1751 10.6653 14.4088 11.3737C13.9663 11.783 13.7428 12.2931 13.6849 12.8858C13.5657 14.1066 14.5022 15.222 15.6566 15.2317V15.2323ZM6.36954 13.0583C6.36782 13.2795 6.38903 13.4985 6.45494 13.7088C6.69109 14.4625 7.15937 15.0019 7.94461 15.1859C8.62897 15.3464 9.23424 15.1423 9.7157 14.6322C10.5107 13.7908 10.5371 12.4587 9.79251 11.568C9.11044 10.7524 7.94174 10.6481 7.13644 11.3388C6.61142 11.7887 6.3747 12.3733 6.37012 13.0577L6.36954 13.0583Z"
      fill="currentColor"
    />
  </svg>
)

const zendeskSvg = () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2867 19.2431H2.00195C5.10172 15.5034 8.18039 11.7889 11.2867 8.0415V19.2431Z"
      fill="currentColor"
    />
    <path
      d="M12.8555 15.1947V4.00732H22.13C19.0408 7.73362 15.9666 11.4417 12.8555 15.1947Z"
      fill="currentColor"
    />
    <path
      d="M12.833 19.2411C12.9235 17.4492 13.6819 16.0647 15.2373 15.2089C16.8945 14.2971 18.57 14.3807 20.1383 15.4402C21.4616 16.3341 22.1027 17.6322 22.1583 19.2411H12.833Z"
      fill="currentColor"
    />
    <path
      d="M2.00362 4H11.2968C11.2445 5.58093 10.6204 6.86685 9.32718 7.75917C7.71217 8.87344 5.9949 8.94121 4.28615 7.97869C2.56076 7.00685 1.94641 5.20558 2.00362 4Z"
      fill="currentColor"
    />
  </svg>
)

const GithubIcon = (props) => <Icon component={GithubSvg} {...props} />
const DiscordIcon = (props) => <Icon component={discordSvg} {...props} />
const ZendeskIcon = (props) => <Icon component={zendeskSvg} {...props} />

const ICONS: Record<SocialMediaChannel, React.FC<any>> = {
  medium: MediumOutlined,
  twitter: TwitterOutlined,
  discord: DiscordIcon,
  github: GithubIcon,
  zendesk: ZendeskIcon,
}

const MediaIcon: React.FC<{ href: string; type: SocialMediaChannel }> = ({
  href,
  type,
}) => {
  const [isHovering, setupHover] = useHover()
  const { t } = useTranslation()
  const Comp = ICONS[type]
  const { trackElClick } = useGA()
  return (
    <>
      <Tooltip title={t(`media_${type}`)}>
        <StyledLink href={href} title={type} target="_blank" {...setupHover}>
          <Comp
            data-trackid="webtl_bottom_media"
            data-trackdata={JSON.stringify({ title: type, url: href })}
            onClick={trackElClick}
            style={{
              fontSize: 24,
              color: isHovering ? '#5F55A9' : '#A7AED2',
              isHovering,
            }}
          />
        </StyledLink>
      </Tooltip>
    </>
  )
}

export const SocialMedia: React.FC = () => {
  return (
    <>
      <StyledFooterSocialMedia>
        <MediaIcon type="twitter" href={MEDIA_LINK.twitter} />
        <MediaIcon type="github" href={MEDIA_LINK.github} />
        <MediaIcon type="medium" href={MEDIA_LINK.medium} />
        <MediaIcon type="discord" href={MEDIA_LINK.discord} />
        <MediaIcon type="zendesk" href={MEDIA_LINK.zendesk} />
      </StyledFooterSocialMedia>
    </>
  )
}
